import { Icon, InlineStack, Link, Tooltip } from '@customerio/pluma-components/react';
import type { Delivery } from '@/services/db/delivery/entity';
import { isEmptyString } from '@/utils/string';
import { channelValueOf, getDeliveryChannel } from '../../catalog';

type ActionCellProps = {
  delivery: Delivery;
  /** Builds the detail (or draft) href for a row — supplied by the page. */
  getDeliveryHref: (delivery: Delivery) => string;
};

/**
 * "Action" cell — the channel icon (with a name tooltip) plus the message
 * subject as a link to the delivery detail. Ported from Ember `cells/action`.
 */
export function ActionCell({ delivery, getDeliveryHref }: ActionCellProps) {
  const channelValue = channelValueOf(delivery.action_type);
  const channel = getDeliveryChannel(channelValue);
  const subject = isEmptyString(delivery.subject) ? '(No subject)' : delivery.subject;

  return (
    <InlineStack alignBlock="center" gap="100" minW="0">
      <Tooltip content={channel?.name ?? channelValue} placement="top">
        <Icon name={channel?.icon ?? 'help'} size="sm" />
      </Tooltip>
      {/* `delivery.subject` is the rendered, per-recipient subject (often personalized). It's
          fs-masked out of FullStory session replay; we deliberately don't wrap it in a `Tooltip`
          because `Tooltip` `content` is a plain string that renders in an unmaskable portal — the
          full subject is available on the detail page it links to. */}
      <Link className="fs-mask" href={getDeliveryHref(delivery)} truncate>
        {subject}
      </Link>
    </InlineStack>
  );
}
